import classes from './Footer.module.scss';

import { FC } from 'react';

const Disclaimer: FC = () => {
  return (
    <div className={`container ${classes.disclaimer}`}>
      <p>MouseOver is a trademark of MouseOver LLC (Ukraine).</p>
      <p>In the EU, services are provided by Overmind OÜ (Estonia, EU).</p>
      <br />
      <p>MouseOver.io is operated by Overmind OÜ, reg. no. 17313660, VAT: EE102896154</p>
      <p>Registered office: Harju maakond, Tallinn, Lasnamäe linnaosa, Sepapaja tn 6, 11415</p>
    </div>
  );
};

export default Disclaimer;
